import script from "./Certification.vue?vue&type=script&setup=true&lang=ts"
export * from "./Certification.vue?vue&type=script&setup=true&lang=ts"

import "./Certification.vue?vue&type=style&index=0&id=589fa8d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589fa8d0"]])

export default __exports__